<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <vuexy-logo :to="{ name: 'home' }" />
        <h2 class="mb-1">
          Página no encontrada
        </h2>
        <p class="mb-2">
          Oops! 😖 La URL solicitada no se encontró en este servidor.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{ name: 'home' }"
        >
          Volver al inicio
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BButton } from "bootstrap-vue"
import VuexyLogo from "@core/layouts/components/Logo.vue"
import store from "@/store/index"

export default {
  components: {
    VuexyLogo,
    BButton,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/error.svg"),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/error.svg")

        return this.downImg
      }

      return this.downImg
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
